export type RectLike = { left: number; top: number; width: number; height: number };

/** 束の中心から捨て札ゾーンの中心への移動量（px）。CSS変数に渡して transition で運ぶ。 */
export function carryDelta(from: RectLike, to: RectLike): { x: number; y: number } {
  return {
    x: to.left + to.width / 2 - (from.left + from.width / 2),
    y: to.top + to.height / 2 - (from.top + from.height / 2),
  };
}
